// MacOnlineBadge — mostra se o runner (Mac) está online, antes de disparar.

export default function MacOnlineBadge({ online }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs text-apolo-textTertiary"
      aria-label={online ? 'Mac online' : 'Mac offline'}
    >
      <span
        className={`h-2 w-2 rounded-full ${online ? 'bg-emerald-500' : 'bg-zinc-500'}`}
        aria-hidden="true"
      />
      {online ? 'Mac online' : 'Mac offline'}
    </span>
  );
}
